import { ConsentResolutionSource } from '../../datagrail/datagrail';

let ga4Loaded = false;
let ga4LoadError: string | undefined;
let analyticsConsentGranted = false;
let consentResolvedVia: ConsentResolutionSource | undefined;
let consentResolutionWaitMs: number | undefined;

export const setGa4Loaded = () => {
  ga4Loaded = true;
  ga4LoadError = undefined;
};

export const isGa4Loaded = () => ga4Loaded;

export const setGa4LoadError = (message: string) => {
  ga4LoadError = message;
};

export const getGa4LoadError = () => ga4LoadError;

export const setAnalyticsConsentGranted = (granted: boolean) => {
  analyticsConsentGranted = granted;
};

export const isAnalyticsConsentGranted = () => analyticsConsentGranted;

export const setConsentResolution = (resolvedVia: ConsentResolutionSource, waitMs: number) => {
  consentResolvedVia = resolvedVia;
  consentResolutionWaitMs = waitMs;
};

export const getConsentResolvedVia = () => consentResolvedVia;

export const getConsentResolutionWaitMs = () => consentResolutionWaitMs;
